import { Link } from "react-router-dom";
import TimelineItem from "./TimelineItem";

const Timeline = ({ degree, clickableTitle }) => {
  return (
    <div className="flex flex-col p-6">
      {clickableTitle ? (
        <Link to={`/degree/${degree?.degree_slug}`}>
          <h2 className="text-2xl font-bold text-lz-ink-mid dark:text-lz-concrete mb-8 hover:underline">
            {degree?.degree}
          </h2>
        </Link>
      ) : (
        <h2 className="text-2xl font-bold text-lz-ink-mid dark:text-lz-concrete mb-8">
          {degree?.degree}
        </h2>
      )}

      <div className="flex flex-col space-y-2 pl-2">
        {degree?.lessons
          ?.sort((a, b) => a.display_order - b.display_order)
          .map((item, index, sortedArray) => (
            <TimelineItem
              key={index}
              title={item.title}
              link={`/lessons/${item.slug}`}
              status={item.status}
              isLast={index === sortedArray.length - 1}
            />
          ))}
      </div>
    </div>
  );
};

export default Timeline;
